// @ts-nocheck
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAccount from "classes/Accounts/hooks/useAccount";
import TagLabel from "components/Tags/Label/TagLabel";
import genRequest from "includes/request";
import React from "react";
import { useQuery } from "react-query";
import "./HighlightedCategories.css";

export default function HighlightedCategories(props) {
	const { account, getSettings } = useAccount();

	const handleClick = (item) => {
		if (props.onItemClick) props.onItemClick(item);
	};

	const fetch = () =>
		genRequest(
			"categories/company/" + account.companyId + "/type/" + props.typeId
		);

	const { isLoading, data } = useQuery(
		["HighlightedCategories", account.companyId, props.typeId],
		fetch,
		{
			enabled: getSettings("FavCategories") !== false,
		}
	);

	if (!getSettings("FavCategories")) return false;
	if (isLoading)
		return (
			<FontAwesomeIcon
				icon={faCircleNotch}
				className="fa-spin"
				color={"var(--color-primary)"}
			/>
		);
	if (!data) return false;
	return (
		<div
			className={"HighlightedCategories d-flex gap-2 " + props.className}
		>
			{data.map((a) => {
				if (!a.isFavorite) return false;
				let isSelected = props.selected?.find(
					(b) => b === a.id
				);
				let color = !props.selected?.length
					? a.categoryColor
					: isSelected
					? a.categoryColor
					: "grey";
				return (
					<TagLabel
						key={a.id}
						text={a.categoryName}
						color={color}
						onClick={() => handleClick(a)}
						style={{
							fontSize: "0.7rem",
							// maxWidth: "unset",
							// width: "100%",
							display: "block",
						}}
					/>
				);
			})}
		</div>
	);
}
